// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bree+Serif&family=Lato&family=Pacifico&family=Roboto:wght@300;400&family=Rubik&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Lato', sans-serif;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

a:hover {
  text-decoration: none;
}

.tiny_size {
  font-size: 11px;
}

.small_text {
  font-size: 11px;
  text-decoration: underline;
  margin-left: 5px;
}

.bold_mak {
  font-weight: 800;
}

.loader-wrapper {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: grid;
  place-items: center;
}

.loader {
  border: 16px solid #e3e3e3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

.selectcategory {
  border: 1px solid #d1d3e2;
  padding: 4px;
  border-radius: 5px;
  cursor: pointer;
}

.subcategory {
  border: 1px solid #d1d3e2;
}

.subcategory li {
  cursor: pointer;
}


.showdiv{
  display: block;
}
.hidediv{
  display: none;
}

.subcategory ul {
  list-style: none;
}

input[type="search"],
select,
input[type="date"] {
  border: 1px solid #aaa;
  border-radius: 3px;
  padding: 5px;
  background-color: transparent;
  margin-left: 3px;
  /* margin-bottom: 10px; */
}

/* Igm on_issues Css start */
#StatusLight input[type="radio"].OPEN {
  accent-color: #ff0000;
}

#StatusLight input[type="radio"].CREATED {
  accent-color: #ff0000;
}

#StatusLight input[type="radio"].RESOLVED {
  accent-color: #00ff00;
}

#StatusLight input[type="radio"].Closed {
  accent-color: #00ff00;
}

#StatusLight input[type="radio"].PROCESSING {
  accent-color: #ffcc00;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  width: 5px;
  /* background: #f5f5f5; */
}

::-webkit-scrollbar-thumb {
  width: 1em;
  background-color: #ddd;
  /* outline: 1px solid slategrey; */
  border-radius: 1rem;
}

.text-small {
  font-size: 0.9rem;
}

/* Igm on_issues Css End */

.genericlabel {
  font-size: 14px;
  font-weight: 600;
  color: black;
}


.multiOrderStatusSelector{
  width: 400px;
}

/*Login Css  */
.main_container {
  width: 65% !important;
}

.main_container .image_wrapper .imagesSetup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.login_btn {
  background: #11335b;
}

.main_container .image_wrapper .image1 img {
  border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
}

.main_container .loginFormat .form_padding {
  padding-inline-start: 30px !important;
}

::placeholder {
  padding-left: 10px;
}

.loginFormat .Icons {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translate(-50%, -50%);
  line-height: 1;
  color: #000000;
}


.category_list {
  margin-left: 20px;
  max-height: 300px;
  overflow: scroll;
}
.selectcategory {
  border: 1px solid #d1d3e2;
  padding: 5px;
  cursor: pointer;
  border-radius: 4px;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media(max-width: 461px){
  .main_container {
    width: 100% !important;
  }

}

@media(max-width: 767px){
  .showdiv{
    display: none;
  }
  .hidediv{
    display: block;
  }
  
}

/*  */
.list-group-item {
  background-color: #f8f9fa; /* Light background for better contrast */
  transition: background-color 0.3s;
}

.list-group-item:hover {
  background-color: #e2e6ea; /* Slightly darker on hover */
}

.modal-title {
  font-weight: 600; /* Bold title */
}

.fw-bold {
  color: #495057; /* Darker color for better readability */
}


/*  */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAIA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0BAA0B;;AAE1B;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;;AAGA;EACE,YAAY;AACd;;AAEA,cAAc;AACd;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB;;;AAGA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;AAEF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;;AAEF;;AAEA,KAAK;AACL;EACE,yBAAyB,EAAE,yCAAyC;EACpE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB,EAAE,6BAA6B;AAC1D;;AAEA;EACE,gBAAgB,EAAE,eAAe;AACnC;;AAEA;EACE,cAAc,EAAE,wCAAwC;AAC1D;;;AAGA,KAAK","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Bree+Serif&family=Lato&family=Pacifico&family=Roboto:wght@300;400&family=Rubik&display=swap');\n\n\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: 'Lato', sans-serif;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\na:hover {\n  text-decoration: none;\n}\n\n.tiny_size {\n  font-size: 11px;\n}\n\n.small_text {\n  font-size: 11px;\n  text-decoration: underline;\n  margin-left: 5px;\n}\n\n.bold_mak {\n  font-weight: 800;\n}\n\n.loader-wrapper {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: grid;\n  place-items: center;\n}\n\n.loader {\n  border: 16px solid #e3e3e3;\n  border-top: 16px solid #3498db;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n}\n\n.selectcategory {\n  border: 1px solid #d1d3e2;\n  padding: 4px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.subcategory {\n  border: 1px solid #d1d3e2;\n}\n\n.subcategory li {\n  cursor: pointer;\n}\n\n\n.showdiv{\n  display: block;\n}\n.hidediv{\n  display: none;\n}\n\n.subcategory ul {\n  list-style: none;\n}\n\ninput[type=\"search\"],\nselect,\ninput[type=\"date\"] {\n  border: 1px solid #aaa;\n  border-radius: 3px;\n  padding: 5px;\n  background-color: transparent;\n  margin-left: 3px;\n  /* margin-bottom: 10px; */\n}\n\n/* Igm on_issues Css start */\n#StatusLight input[type=\"radio\"].OPEN {\n  accent-color: #ff0000;\n}\n\n#StatusLight input[type=\"radio\"].CREATED {\n  accent-color: #ff0000;\n}\n\n#StatusLight input[type=\"radio\"].RESOLVED {\n  accent-color: #00ff00;\n}\n\n#StatusLight input[type=\"radio\"].Closed {\n  accent-color: #00ff00;\n}\n\n#StatusLight input[type=\"radio\"].PROCESSING {\n  accent-color: #ffcc00;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n}\n\n::-webkit-scrollbar-track {\n  width: 5px;\n  /* background: #f5f5f5; */\n}\n\n::-webkit-scrollbar-thumb {\n  width: 1em;\n  background-color: #ddd;\n  /* outline: 1px solid slategrey; */\n  border-radius: 1rem;\n}\n\n.text-small {\n  font-size: 0.9rem;\n}\n\n/* Igm on_issues Css End */\n\n.genericlabel {\n  font-size: 14px;\n  font-weight: 600;\n  color: black;\n}\n\n\n.multiOrderStatusSelector{\n  width: 400px;\n}\n\n/*Login Css  */\n.main_container {\n  width: 65% !important;\n}\n\n.main_container .image_wrapper .imagesSetup {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.login_btn {\n  background: #11335b;\n}\n\n.main_container .image_wrapper .image1 img {\n  border-bottom-left-radius: 15px;\n  border-top-left-radius: 15px;\n}\n\n.main_container .loginFormat .form_padding {\n  padding-inline-start: 30px !important;\n}\n\n::placeholder {\n  padding-left: 10px;\n}\n\n.loginFormat .Icons {\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  line-height: 1;\n  color: #000000;\n}\n\n\n.category_list {\n  margin-left: 20px;\n  max-height: 300px;\n  overflow: scroll;\n}\n.selectcategory {\n  border: 1px solid #d1d3e2;\n  padding: 5px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@media(max-width: 461px){\n  .main_container {\n    width: 100% !important;\n  }\n\n}\n\n@media(max-width: 767px){\n  .showdiv{\n    display: none;\n  }\n  .hidediv{\n    display: block;\n  }\n  \n}\n\n/*  */\n.list-group-item {\n  background-color: #f8f9fa; /* Light background for better contrast */\n  transition: background-color 0.3s;\n}\n\n.list-group-item:hover {\n  background-color: #e2e6ea; /* Slightly darker on hover */\n}\n\n.modal-title {\n  font-weight: 600; /* Bold title */\n}\n\n.fw-bold {\n  color: #495057; /* Darker color for better readability */\n}\n\n\n/*  */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
